import { Component, OnInit } from '@angular/core';
import { ChartConfiguration, ChartOptions, ChartType } from 'chart.js';
import { StatisticsService } from '../../statistics/statistics.service';
import { UntypedFormControl } from '@angular/forms';
import { MonthModel } from '../../../shared/components/table/month.model';
import { months, monthsNumeric } from '../../../consts';
import { ActualSelected } from '../../../shared/utils';
import { StatisticsExpensesModel } from '../../statistics/statistics.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { chartPalette, gradientFill, tooltipBase, horizontalBarScalesBase, barGeometry } from '../../resume/charts/chart-theme';

@Component({
    selector: 'convfact-expense-statistics',
    templateUrl: './expense-statistics.component.html',
    styleUrls: ['./expense-statistics.component.css'],
    standalone: false
})

export class ExpenseStatisticsComponent implements OnInit {

  public statisticsExpenses: StatisticsExpensesModel;

  public monthControl = new UntypedFormControl();
  public monthsSelected: string[];
  public monthList: MonthModel[] = [];
  public allMonthsSelected = false;

  public requestReady: boolean = false;

  public chartType: ChartType = 'bar';

  // ----- Proveedor al que mas le compro -----

  public chartDataSupplierFromWhomIBuyTheMost: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: [],
      label: 'Total comprado',
      backgroundColor: gradientFill(chartPalette.expense),
      hoverBackgroundColor: chartPalette.expense,
      ...barGeometry
    }]
  };

  public chartOptionsSupplierFromWhomIBuyTheMost: ChartOptions<'bar'> = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 700, easing: 'easeOutQuart' },
    scales: horizontalBarScalesBase(),
    plugins: { legend: { display: false }, tooltip: tooltipBase() }
  };

  // ----- Proveedor al que mas le debo -----

  public chartDataSupplierToWhomIOweTheMost: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: [],
      label: 'Total adeudado',
      backgroundColor: gradientFill(chartPalette.warning),
      hoverBackgroundColor: chartPalette.warning,
      ...barGeometry
    }]
  };

  public chartOptionsSupplierToWhomIOweTheMost: ChartOptions<'bar'> = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 700, easing: 'easeOutQuart' },
    scales: horizontalBarScalesBase(),
    plugins: { legend: { display: false }, tooltip: tooltipBase() }
  };

  constructor(public statisticsService: StatisticsService, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.setMonths();

    this.loadStatistics();
  }

  public loadStatistics(): void {
    this.requestReady = false;

    this.statisticsService.listStatisticsExpenses()
      .then((response: StatisticsExpensesModel) => {
        this.requestReady = true;
        this.statisticsExpenses = response;
        this.fillInCharts();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error inesperado al cargar las estadisticas de los gastos");
      });
  }

  public fillInCharts(): void {
    // Proveedores al que mas le compro
    this.chartDataSupplierFromWhomIBuyTheMost = {
      labels: this.statisticsExpenses.supplierFromWhomIBuyTheMostViewModel.map(x => x.providerName),
      datasets: [{
        data: this.statisticsExpenses.supplierFromWhomIBuyTheMostViewModel.map(x => x.totalPurchased),
        label: 'Total comprado',
        backgroundColor: gradientFill(chartPalette.expense),
        hoverBackgroundColor: chartPalette.expense,
        ...barGeometry
      }]
    };

    // Proveedores al que mas le debo
    this.chartDataSupplierToWhomIOweTheMost = {
      labels: this.statisticsExpenses.supplierToWhomIOweTheMostViewModel.map(x => x.providerName),
      datasets: [{
        data: this.statisticsExpenses.supplierToWhomIOweTheMostViewModel.map(x => x.totalDebt),
        label: 'Total adeudado',
        backgroundColor: gradientFill(chartPalette.warning),
        hoverBackgroundColor: chartPalette.warning,
        ...barGeometry
      }]
    };
  }

  public setMonths(): void {
    if (this.monthList.length === 0) {
      let i = 1;
      months.forEach(element => {
        const newMonth = new MonthModel();
        newMonth.name = element;
        newMonth.selected = true;
        newMonth.number = i.toString();
        this.monthList.push(newMonth);
        i += 1;
      });
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedStatistics = monthsNumeric;
    }
  }

  public onChangeMonth(event): void {
    this.monthsSelected = event.value;
    ActualSelected.monthSelectedStatistics = event.value;
    this.allMonthsSelected = false;

    this.monthList.forEach(element => element.selected = false);
    event.value.forEach(element => {
      this.monthList.find(f => f.number == element).selected = true;
    });

    this.loadStatistics();
  }

  public onSelectAll(event): void {
    if (event.checked) {
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedStatistics = monthsNumeric;
      this.monthList.forEach(element => element.selected = true);
    } else {
      this.allMonthsSelected = false;
      this.monthsSelected = [];
      ActualSelected.monthSelectedStatistics = [];
      this.monthList.forEach(element => element.selected = false);
    }

    this.loadStatistics();
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public trackByIndex(i: number) { return i; }

}
